var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIydAboutImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 836,
    height: 772,
    viewBox: "0 0 836 772",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-86.7506 697.286L-15.147 922.5L240.824 885.469L595.847 697.285L453.557 389.277L125.807 556.014L-86.7506 697.286Z",
    fill: "url(#paint0_linear_5925_9431)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.501 85.4988L-120.809 407.422L-86.7506 697.286L125.807 556.014L453.557 389.277L266.501 85.4988Z",
    fill: "url(#paint1_linear_5925_9431)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M266.015 84.6124C266.015 84.6124 363.116 243.544 466.381 274.444C569.647 305.344 634.641 274.444 634.641 274.444C634.641 274.444 579.154 322.969 548.254 426.235C517.354 529.501 596.829 697.939 596.829 697.939C596.829 697.939 499.729 539.007 396.463 508.107C293.197 477.208 124.759 556.683 124.759 556.683C124.759 556.683 283.691 459.582 314.591 356.317C345.491 253.051 266.015 84.6124 266.015 84.6124Z",
    fill: "#385738"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5925_9431",
    x1: -1.62885,
    y1: 246.387,
    x2: 373.453,
    y2: 941.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.620192,
    stopColor: "#2A412A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172617"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5925_9431",
    x1: -8.4569,
    y1: 233.805,
    x2: 321.383,
    y2: 845.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "#203220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324932"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIydAboutImg);
export default __webpack_public_path__ + "static/media/IYDAboutImg.3ed1281dc426d55276467df52423fc9d.svg";
export { ForwardRef as ReactComponent };